module.exports = __webpack_public_path__ + "img/westrock.a5483ce2.jpg";